import { render, staticRenderFns } from "./dok_rencana_skpd.vue?vue&type=template&id=04a59627&"
import script from "./dok_rencana_skpd.vue?vue&type=script&lang=js&"
export * from "./dok_rencana_skpd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports